import { nanoId } from '@/helpers'
import { _plus, _minus, _times, _div, _toFixed, _percentage } from '@/helpers/bigNumber'
import { isIRPF } from '@/helpers/checkTaxIsIRPF'

export const set = ({ commit, dispatch }, payload) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(payload)) reject(new Error(`${payload} must be an array`))
    Promise.all(
      payload.map(detail => dispatch('insertDetail', detail))
    ).then(() => {
      resolve()
    }, (err) => {
      reject(err)
    })
  })
}

/**
 * Insert Invoice Detail Line
 * @param {Object} value - Form detail Object.
 */
export const insertDetail = ({ dispatch, commit, state, getters }, value) => {
  return new Promise((resolve) => {
    let key = nanoId(8)
    if (!value.amount) value.amount = _toFixed(_times(_div(value.product.totalAmount, value.product.count), value.quantity), 2)
    if (value.discountsCharges) {
      value.discountsCharges = value.discountsCharges.map(x => {
        if (x.base !== value.amount) x.base = value.amount
        if (!x.amount && x.percent) x.amount = _times(x.base, _percentage(x.percent))
        return x
      })
    }
    if (!value.discountsPercent) {
      value.discountsPercent = value.discountsCharges
                                ? value.discountsCharges.reduce((acc, x) => {
                                  return x.type === '1'
                                    ? _plus(acc, Number(x.percent))
                                    : _minus(acc, Number(x.percent))
                                }, 0)
                                : 0
    }
    if (!value.totalDiscounts) {
      value.totalDiscounts = value.discountsCharges
                              ? _toFixed(value.discountsCharges.reduce((acc, x) => {
                                return x.type === '1'
                                  ? _plus(acc, Number(x.amount))
                                  : _minus(acc, Number(x.amount))
                              }, 0), 2)
                              : 0
    }
    if (!value.amountBeforeTaxes) value.amountBeforeTaxes = _plus(value.amount, value.totalDiscounts)
    if (!value.taxesPercent) {
      value.taxesPercent = value.taxes ? value.taxes.reduce((acc, x) => {
        return isIRPF(x.type)
          ? x.percent < 0 && x.percent !== undefined
            ? _plus(acc, x.percent)
            : _minus(acc, x.percent)
          : _plus(acc, x.percent)
      }, 0) : 0
    }
    // 70621 No se emplea el total de impuestos por linea
    if (!value.subtotal) value.subtotal = _toFixed(value.amountBeforeTaxes, 2) //, value.totalTaxes)
    commit('ADD_DETAIL', { key, value })
    dispatch('invoice/rebaseGlobalDiscounts', {}, { root: true })
    .then(() => {
      resolve()
    })
  })
}

export const updateDetail = ({ commit, state, dispatch }, { key, value }) => {
  return new Promise((resolve) => {
    commit('EDIT_DETAIL', { key, value })
    dispatch('invoice/rebaseGlobalDiscounts', {}, { root: true })
    .then(() => {
      resolve()
    })
  })
}

export const upsertDetail = ({ commit, dispatch, state }, { key, value }) => {
  return new Promise((resolve) => {
    if (key) {
      dispatch('updateDetail', { key, value })
      .then(() => {
        resolve()
      })
    } else {
      dispatch('insertDetail', value)
      .then(() => {
        resolve()
      })
    }
  })
}

export const deleteDetail = ({ commit, state, dispatch }, { key }) => {
  return new Promise((resolve) => {
    commit('DELETE_DETAIL', { key })
    dispatch('invoice/rebaseGlobalDiscounts', {}, { root: true })
    .then(() => {
      resolve()
    })
  })
}

export const empty = ({ commit, dispatch, state }) => {
  return new Promise((resolve) => {
    if (!state.list.length) resolve()
    Promise.all([
      state.list.map((key) => {
        return dispatch('deleteDetail', {key})
      })
    ]).then(() => {
      resolve()
    })
  })
}
